var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"container"}},[_c('vs-row',{staticStyle:{"height":"80px"}},[_c('div',{staticClass:"centerx"},[_c('vs-navbar',{staticClass:"myNavbar",attrs:{"color":"#F8F8F8","type":"flat"}},[_c('div',{attrs:{"slot":"title"},slot:"title"},[_c('vs-navbar-title',[_vm._t("title")],2)],1),_vm._t("default")],2)],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }